import { render } from "./productAddedModal.vue?vue&type=template&id=089139ca&scoped=true&ts=true"
import script from "./productAddedModal.vue?vue&type=script&lang=ts"
export * from "./productAddedModal.vue?vue&type=script&lang=ts"

import "./productAddedModal.vue?vue&type=style&index=0&id=089139ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089139ca"]])

export default __exports__